import {GET_TYPES } from "../actions/types";

const initialState=[]

export default function types(state = initialState, action) {
    switch (action.type) {
      case GET_TYPES:
        return action.payload;
      default:
        return state;
    }
  }